import React from "react";
import dynamic from "next/dynamic";

const BookConsultant = dynamic(() => import('../services/service-book-consultant/bookconsultant'))
const BlogArticles = dynamic(() => import('./blog-articles/blog-articles'))
const BlogDigital = dynamic(() => import('./blog-digital/blog-digital'))
const BlogMigration = dynamic(() => import('./blog-migration/blog-migration'))
// const FaqSection = dynamic(() => import('../home/faq/faq-section'))

function BlogDetails(props) {
	let data = props.blocks;
	let faq = data?.blocks?.find(item => item.__component === "blocks.faq");

	return (
		<>
			<div className="blog-detail-development bg-one">
				<BlogDigital block={data} authors={data?.authors} />
				{data?.blocks ? data?.blocks?.length > 0 &&
					<>
						{
							data.blocks.map((block, i) => {
								return (
									<React.Fragment key={i}>
										{
											block.__component === "blocks.blog-paragraph" &&
											<BlogMigration block={block} faq={faq} authors={data.authors} />
										}
										{
											block.__component === "blocks.related-articles" &&
											<BlogArticles block={block} />
										}
										{
											block.__component === "blocks.cta" &&
											<BookConsultant block={block} />
										}
										{/* {
											block.__component === 'blocks.faq' &&
											<FaqSection faqs={block} />
										} */}
									</React.Fragment>
								)
							})
						}
					</>
					: null}
			</div>
		</>
	);
}

export default BlogDetails;
